import React, { useRef, useState, useEffect } from "react";
import videojs from "video.js";
import { Docubytes } from "../../Model/Content"; //Include Home
import { SVGIcons, ImgIcons } from "../../Helpers/Common";
import Stories, { WithSeeMore } from "react-insta-stories";
import { Swiper, SwiperSlide } from "swiper/react";
import { Mobilemenu } from "../Mobile_menu/Mobilemenu";
import PageNotFound from "../PageNotFound/PageNotFound";
import { Pagination } from "swiper";
import $ from "jquery";
import { userprofile } from "../../Model/Users";
import { Genrelist } from "../../Model/Content";
import BarLoader from "react-spinners/BarLoader";
import { motion } from "framer-motion";
import { FreeMode, Navigation, Thumbs } from "swiper";
import Header from "../common/Header";
import { Metadata } from "../Metadata/Metadata";

var ImageData = "";
var SVGIcon = "";

ImgIcons().then((result) => (ImageData = result));
SVGIcons().then((resultData) => (SVGIcon = resultData));

export default function DocubytesSwiper({
  channel,
  song,
  url,
  likes,
  comment,
  shares,
  Videodata,
}) {
  const [isVideoPlaying, setisVideoPlaying] = useState(false);
  const [player, setPlayer] = useState(false);
  const [scrollstatus, setscrollstatus] = useState(false);
  const [Docubytescontent, setDocubytescontent] = useState(false);
  const [userData, setuserData] = useState(false);
  const [Baysdata, setBaysdata] = useState(false);


  const [playurl, setplayurl] = useState("");
  var vidRef = useRef([]);
  const [thumbsSwiper, setThumbsSwiper] = useState(null);
  const swiperRef = useRef(null)
  const onVideoClick = () => {
    /*if (isVideoPlaying) {
      setisVideoPlaying(false);
    } else {
      vidRef.current.play();
      setisVideoPlaying(true);
    }*/
  };
  // variable

  // HTML5 vdo object

  function isBottom(el) {
    return el.getBoundingClientRect().bottom <= window.innerHeight;
  }

  useEffect(() => {
    getData();
  }, []);


  const getData = () => {

    Docubytes(0, 100).then((res) => {

      userprofile().then((userDatares) => {

        var parseUserdata = JSON.parse(userDatares.data.message);

        if (userDatares.data.message == "session_expired" || parseUserdata.errorcode == "1008") {
          this.props.navigate("/createaccount");

        } else {
          Genrelist().then((GenreData) => {
            if (GenreData.data) {

              var userDatares = parseUserdata
              setuserData(res.data);
              setDocubytescontent(res.data);
              setBaysdata(GenreData.data.message.Genres);

            } else {

            }
          })
        }
      });


    });
  };

  if (Docubytescontent == false) {
    // return <div className="loader"></div>;
    return <div className="loader"><BarLoader color="#ff000f" /></div>;
  }

  function getswiper(activeIndex, snapIndex, previousIndex, realIndex) {
    console.log("heheheheh")
    setPlayer(false);
    console.log(activeIndex, snapIndex, previousIndex, realIndex);
    if (Docubytescontent) {
      var Content = Docubytescontent.message.contents;
      var Videodata = Content[activeIndex];
      var Previousvideo = Content[activeIndex - 1];
    }

    if (previousIndex - realIndex == 1 || previousIndex - realIndex == -1) {
      if (activeIndex > previousIndex) {
        console.log("scroll down");



        var Previousvideo = Content[activeIndex - 1];
        if (vidRef.current[Previousvideo.ID]) {
          const p1 = videojs(vidRef.current[Previousvideo.ID]);
          p1.pause();
          p1.currentTime(0);
        }

        setplayurl(Videodata.preview_url.preview_url1);

        var getplayers = videojs.getPlayers();
        var currentp = Videodata.ID;
        var allplayer = Object.keys(getplayers);

        if (allplayer.includes(Videodata.ID.toString())) {
          const dd = videojs(Videodata.ID.toString());

          //When ready, start playback
          dd.ready(function () {
            dd.play();
          });
        } else {
          var overrideNative = false;
          var videoJsOptions = {
            html5: {
              hls: {
                overrideNative: overrideNative
              },
              nativeVideoTracks: !overrideNative,
              nativeAudioTracks: !overrideNative,
              nativeTextTracks: !overrideNative
            },
            hls: {
              overrideNative: overrideNative
            },
            autoplay: true,
            autoPlay: true,
            kind: "captions",
            fluid: true,
            preload: "none",
            aspectRatio: "15:15",
            height: "auto",
            width: "100%",
            nativeControlsForTouch: false, //nativeControlsForTouch for player js
            disablePictureInPicture: false,
            controls: false,
            sources: [
              {
                src: Videodata.preview_url.preview_url1,
                type: "application/x-mpegURL",
                withCredentials: false,
              },
            ],
          };
          //var p = videojs(vidRef.current[Videodata.ID], "");
          var p = videojs(vidRef.current[Videodata.ID], videoJsOptions, () => {

            p.play()
            setPlayer(p);
            console.log(player)

            if (!p.paused()) {
              console.log("Video is playing");
            } else {
              p.play()
              console.log("Video is paused");
            }
            /*if(p.paused()){
                        p.play()
                      }*/
            return () => {
              if (player) {
                player.dispose();
              }
            };
          });
          p.src([
            {
              src: Videodata.preview_url.preview_url1,
              type: 'application/x-mpegURL',
            }
          ]);
          setplayurl(Videodata.preview_url.preview_url1);
          p.play();

        }
      } else {
        console.log("scroll up");
        var Previousvideo = Content[activeIndex + 1];
        console.log(
          Previousvideo.ID + " -- Previous" + Videodata.ID + "-- Current"
        );
        if (vidRef.current[Previousvideo.ID]) {

          var p1 = videojs(vidRef.current[Previousvideo.ID]);
          p1.pause();
          p1.currentTime(0);
          var videoJsOptions = {
            html5: {
              hls: {
                overrideNative: overrideNative
              },
              nativeVideoTracks: !overrideNative,
              nativeAudioTracks: !overrideNative,
              nativeTextTracks: !overrideNative
            },
            hls: {
              overrideNative: overrideNative
            },
            autoplay: true,
            kind: "captions",
            preload: "none",
            aspectRatio: "15:15",
            height: "auto",
            width: "100%",
            nativeControlsForTouch: false, //nativeControlsForTouch for player js
            disablePictureInPicture: false,
            controls: false,
            sources: [
              {
                src: Videodata.preview_url.preview_url1,
                type: "application/x-mpegURL",
                withCredentials: false,
              },
            ],
          };
          setplayurl(Videodata.preview_url.preview_url1);

          /*const p1 = videojs(vidRef.current[Previousvideo.ID], videoJsOptions);
        p1.currentTime = 0;*/

          var p = videojs("#" + Videodata.ID);
          setPlayer(p);
          if (p) {
            console.log(p.src)
            p.play();

          } else {
            console.log("play  nn")

            console.log(p.play());

          }


        } else {
          console.log("else con")
          var videoJsOptions = {
            html5: {
              hls: {
                overrideNative: overrideNative
              },
              nativeVideoTracks: !overrideNative,
              nativeAudioTracks: !overrideNative,
              nativeTextTracks: !overrideNative
            },
            hls: {
              overrideNative: overrideNative
            },
            autoplay: true,
            autoPlay: true,
            kind: "captions",
            preload: "none",
            aspectRatio: "15:15",
            height: "auto",
            width: "100%",
            controls: false,
            sources: [
              {
                src: Videodata.preview_url_vertical.preview_url1_vertical,
                type: "application/x-mpegURL",
                withCredentials: false,
              },
            ],
          };
          setplayurl(Videodata.preview_url_vertical.preview_url1_vertical);
          /*const p1 = videojs(vidRef.current[Previousvideo.ID], videoJsOptions);
        p1.currentTime = 0;*/
          var p = videojs(vidRef.current[Previousvideo.ID], videoJsOptions);
          setPlayer(p);
          return () => {
            if (player) player.dispose();
          };
          p.play();
        }
      }
    } else {
      //previousIndex, realIndex
      var Previousvideo = Content[previousIndex];
      var Currentvideo = Content[realIndex];

      if (vidRef.current[Previousvideo.ID]) {

        const p1 = videojs(vidRef.current[Previousvideo.ID]);

        if (p1.hasStarted_) {
          p1.pause();
          p1.currentTime(0);
        }


        var videoJsOptions = {
          html5: {
            hls: {
              overrideNative: overrideNative
            },
            nativeVideoTracks: !overrideNative,
            nativeAudioTracks: !overrideNative,
            nativeTextTracks: !overrideNative
          },
          hls: {
            overrideNative: overrideNative
          },
          autoplay: true,
          kind: "captions",
          preload: "none",
          aspectRatio: "15:15",
          height: "auto",
          width: "100%",
          nativeControlsForTouch: false, //nativeControlsForTouch for player js
          disablePictureInPicture: false,
          controls: false,
          sources: [
            {
              src: Currentvideo.preview_url.preview_url1,
              type: "application/x-mpegURL",
              withCredentials: false,
            },
          ],
        };
        setplayurl(Currentvideo.preview_url.preview_url1);

        const c1 = videojs(vidRef.current[Currentvideo.ID], videoJsOptions);
        setPlayer(c1);
        if (c1) {
          c1.play();
        } else {
          console.log(c1.play());

        }

      }


    }
    //console.log(vidRef.current)
  }


  if (Docubytescontent) {

    return (

      <motion.div
        className=""
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        transition={{ duration: 2 }}
        key="1"
      >
        <Metadata page="HOME" />
        <Header userprofile={userData} bayData={Baysdata} page={"home"} classdata={this} />

        <main>
          <section className="mb-0">
            <div className="carousel">
              <Swiper

                spaceBetween={150}
                slidesPerView={1.8}
                centeredSlides={true}

                navigation={true}
                thumbs={{ swiper: thumbsSwiper }}
                modules={[FreeMode, Navigation, Thumbs]}
                className="mySwiper2"
                onSlideChange={(swiperCore) => {
                  const { activeIndex, snapIndex, previousIndex, realIndex } =
                    swiperCore;
                  getswiper(
                    activeIndex,
                    snapIndex,
                    previousIndex,
                    realIndex
                  );
                }}
              >
                {Docubytescontent.message.contents.map((list, i) => {

                  return (
                    <SwiperSlide key={i}>
                      <>
                        <video
                          src={list.preview_url.preview_url1}
                          onClick={onVideoClick}
                          className="video-player-desk"
                          ref={(el) => (vidRef.current[list.ID] = el)}
                          id={list.ID}
                          playsInline={true}
                          webkit-playsinline={true}
                          webkit-playsinline={true}
                          webkit-playsinline=""
                          playsInline=""
                          poster={list.thumbnail_image1.large}
                          x-webkit-airplay="allow"
                          autoPlay
                        />
                        <div className="temp49">
                          <div className="temp110-img"></div>

                        </div>
                      </>
                    </SwiperSlide>
                  );
                })}
              </Swiper>
            </div>
          </section>
          <div className="temp121">
            <div className="temp150-area">
              <Swiper

                onSwiper={setThumbsSwiper}
                spaceBetween={10}
                slidesPerView={5}
                watchSlidesProgress={false}
                initialSlide={4}
                modules={[FreeMode, Navigation, Thumbs]}
                className="mySwiper
                  "
              >
                {Docubytescontent.message.contents.map((list, i) => {

                  return (
                    <SwiperSlide key={i}>
                      <img src={list.preview_image_1.small} width="" />
                    </SwiperSlide>)
                })}
              </Swiper>
            </div>
          </div>
        </main>
      </motion.div>
    );
  } else {
    return (<PageNotFound />)
  }

}
